import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Button, Input, Select } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import Switchbox from '../../../../components/user/from/Switchbox'
import ViewDraftMeeting from '../../../../components/user/from/MeetingManagement/ViewDraftMeeting'
import ViewNoteMeeting from '../../../../components/user/from/MeetingManagement/ViewNoteMeeting'
import SentNoteApproveMeeting from '../../../../components/user/from/MeetingManagement/SentNoteApproveMeeting'
import { UrlMeeting } from '../../../../utils/auth'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";

const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;
const { Text, Title } = Typography

class NoteMeeting extends React.Component {

    state = {
        dataMeeting: [],
        // {
        //     id: "1",
        //     title: "ประชุมเพื่อเตรียมความพร้อมประจำปี",
        //     date: "21 ก.พ. 2565 / 10:00 - 14:00 น.",
        //     address: "อาคาร 4 ห้อง 424",
        //     people: 12,
        //     full_people: 13,
        //     type: "wait",
        //     accept: "wait",
        //     like: true,
        //     comment: "123123123123",
        // },

    }

    componentDidMount = () => {
        this.fetchDateMeeting();
    }

    fetchDateMeeting = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingagree`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingDate: "",
                MeetingName: "",
                limit: 1000000,
                offset: 0
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                console.log("data", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    acceptSummary = (id) => {
        // console.log("id",id);
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptsummarymeeting`,
            {
                MeetingID: id,
                UserID: sessionStorage.getItem('username'),
                Status: "Accept"
            })
            .then(response => {
                // console.log("response", response);
                this.fetchDateMeeting();
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    commentSummary = (id, note) => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/commentsummarymeeting`,
            {
                MeetingID: id,
                UserID: sessionStorage.getItem('username'),
                ChangeDetail: note
            })
            .then(response => {
                // console.log("response", response);
                this.fetchDateMeeting();
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeSearchNote = (value) => {
        // console.log("value", value);

        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingagree`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingDate: "",
                MeetingName: value,
                offset: 0,
                limit: 1000000,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                // console.log("listmeetinginvited", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    render() {
        const { match } = this.props
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div className="card-container meeting-management" id="create-meeting">
                    <div className="p-5 card-bg-white">
                        <Row gutter={16} className={'py-4 mr-0 ml-0'}>
                            <Col xs={24} lg={12}>
                                <Search
                                    placeholder="ค้นหา"
                                    onSearch={value => this.onChangeSearchNote(value)}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                            {/* <Col xs={24} md={12} lg={5} >
                                <Button className={'button-meeting-search mt-3 mt-lg-0'}>
                                    ค้นหา</Button>
                            </Col> */}
                        </Row>
                        <div style={{ height: 650, width: '100%', overflow: "auto" }}>
                            <ViewNoteMeeting dataMeeting={this.state.dataMeeting} acceptSummary={this.acceptSummary} commentSummary={this.commentSummary}></ViewNoteMeeting>
                        </div>
                    </div>
                </div>
            </Container >
        )
    }
}

NoteMeeting.propTypes = {
    //
}

export default withApollo(NoteMeeting)